import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import 'CssFolder/chart.scss';
import languageModel from "../../../models/language.model";

export default function ScheduleVisitPlanChartComponent() {
    let data;
    let chartId = 'xychart_schedule_visitplan';
    let title = "Store Visit";
    let root;

    let onStoreVisitChartDataChanged = (_data) => {
        if (_data) {
            data = _data;
        }
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom.id == chartId) {
                root.dispose();
            }
        });
        initChart();
    }

    let initChart = () => {
        root?.dispose(); // dispose any pre-existing roots
        
        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        root = am5.Root.new(chartId);

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout
        }));

        chart.children.unshift(am5.Label.new(root, {
            text: title,
            fontSize: 20,
            fontWeight: "500",
            textAlign: "center",
            x: am5.percent(50),
            centerX: am5.percent(50),
            paddingTop: 0,
            paddingBottom: 10
        }));

        chart.get("colors").set("colors", [
            am5.color(0x84E0BE),
            am5.color(0xF9AC19),
            am5.color(0xF38068)
        ]);

        // Add scrollbar
        // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
        /*
        chart.set("scrollbarX", am5.Scrollbar.new(root, {
          orientation: "horizontal"
        }));
        */

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "period",
            renderer: am5xy.AxisRendererX.new(root, {
                cellStartLocation: 0.1,
                cellEndLocation: 0.9,
                minGridDistance: 30
            })
            //tooltip: am5.Tooltip.new(root, {})
        }));

        let xRenderer = xAxis.get("renderer");
        xRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        xRenderer.labels.template.setAll({
            fontSize: 12,
        });

        xAxis.data.setAll(data);

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            min: 0,
            maxPrecision: 0,
            renderer: am5xy.AxisRendererY.new(root, {})
        }));

        let yRenderer = yAxis.get("renderer");
        yRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        yRenderer.labels.template.setAll({
            fontSize: 12,
        });

        // Add legend
        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
        var legend = chart.children.push(am5.Legend.new(root, {
            centerX: am5.p50,
            x: am5.p50
        }));

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        function makeSeries(name, fieldName) {
            var series = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: fieldName,
                categoryXField: "period",
                maskBullets: false
            }));

            series.columns.template.setAll({
                tooltipText: "{name}, {valueY}",
                tooltipY: am5.percent(10)
            });
            series.data.setAll(data);

            // Make stuff animate on load
            // https://www.amcharts.com/docs/v5/concepts/animations/
            series.appear();

            series.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Label.new(root, {
                        text: "{valueY}",
                        fontSize: 12,
                        fill: am5.color(0x001737),
                        centerY: am5.p100,
                        centerX: am5.p50,
                        populateText: true
                    })
                });
            });

            legend.data.push(series);
        }

        makeSeries(languageModel.getText("LT00000311", "Planned Visits"), "target");
        makeSeries(languageModel.getText("LT00000312", "Total Visits"), "actual");
        makeSeries(languageModel.getText("LT00000313", "Unplanned Visits"), "unplanned");

        var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));

        cursor.lineX.setAll({
            visible: false
        });

        cursor.lineY.setAll({
            visible: false
        });

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        chart.appear(1000, 100);
    }

    return {
        oninit: function (vnode) {
        },
        oncreate: function (vnode) {
            if (vnode.attrs.events) {
                vnode.attrs.events.onStoreVisitChartDataChanged = onStoreVisitChartDataChanged;
            }
            if (vnode.attrs.data) {
                data = vnode.attrs.data;
                initChart();
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
            });
        }
    }
}
